export const ENGAGEMENT_LOCATION = 'BEFORE';
export const SNIPPETS_AMOUNT_LIMIT = 20;